var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('my-header'),_c('div',{staticClass:"body"},[_vm._l((_vm.data),function(dt){return _c('card',{key:dt.imp,attrs:{"image":dt.cardimg,"heading":dt.cardHeading,"txt":dt.cardTxt,"imp":dt.imp}})}),_c('float')],2),_c('my-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }